const STORAGE_KEY = 'othello-local-saves'
const MAX_SAVES = 40

function safeParse(raw) {
  try {
    const arr = JSON.parse(raw)
    return Array.isArray(arr) ? arr : []
  } catch {
    return []
  }
}

/**
 * @returns {Array<{ id: string, label: string, savedAt: string, moveCount: number, payload: object }>}
 */
export function readLocalSaves() {
  if (typeof localStorage === 'undefined') return []
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return []
    const arr = safeParse(raw)
    return arr
      .filter(
        (x) =>
          x &&
          typeof x === 'object' &&
          typeof x.id === 'string' &&
          x.payload &&
          typeof x.payload === 'object'
      )
      .sort((a, b) => String(b.savedAt).localeCompare(String(a.savedAt)))
  } catch {
    return []
  }
}

function writeLocalSaves(list) {
  if (typeof localStorage === 'undefined') return
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list.slice(0, MAX_SAVES)))
  } catch {
    throw new Error('QUOTA')
  }
}

/**
 * @param {{ id?: string, label: string, savedAt?: string, moveCount: number, payload: object }} entry
 */
export function appendLocalSave(entry) {
  const id = entry.id || `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`
  const savedAt = entry.savedAt || new Date().toISOString()
  const list = readLocalSaves()
  list.unshift({
    id,
    label: String(entry.label || id),
    savedAt,
    moveCount: Math.max(0, Number(entry.moveCount) || 0),
    payload: entry.payload
  })
  writeLocalSaves(list)
}

export function removeLocalSave(id) {
  const list = readLocalSaves().filter((x) => x.id !== id)
  writeLocalSaves(list)
}
